/**
 * Created by Olga on 13.10.2026
 */

const CollectibleHintView = function () {
    this.hintFinger = undefined;
    this.unitView = undefined;
    this.glow = undefined;
    this.scaleAction = undefined;

    cleverapps.availableMove.on("hide", this.hide.bind(this));
    cleverapps.availableMove.on("collectible", this.show.bind(this));
    cleverapps.availableMove.on("collectible_last", this.show.bind(this));
};

CollectibleHintView.prototype.show = function (move, inTutorial) {
    if (!inTutorial && this.tutorialMode) {
        return;
    }
    this.hide(inTutorial);

    const unitView = move.target;
    if (!unitView.parent) {
        return;
    }

    this.unitView = unitView;

    const delay = move.delay / 1000;

    this.hintFinger = FingerView.hintTap(unitView, {
        delay,
        runOnce: true
    });

    this.scaleAction = unitView.runAction(new cc.Sequence(
        new cc.DelayTime(delay),
        new cc.CallFunc(() => {
            if (this.unitView !== unitView || !unitView.parent) {
                return;
            }

            if (move.glow) {
                this.addGlow();
            }

            this.scaleAction = unitView.runAction(new cc.RepeatForever(new cc.Sequence(
                new cc.ScaleTo(0.5, 1.12).easing(cc.easeInOut(3)),
                new cc.DelayTime(0.8),
                new cc.ScaleTo(0.6667, 1).easing(cc.easeInOut(3))
            )));
        })
    ));
};

CollectibleHintView.prototype.addGlow = function () {
    const glow = this.glow = new cleverapps.Spine(bundles.merge_animations.jsons.collectible_glow_json);
    glow.setAlignment({ align: "center" }, { align: "center" });
    glow.setAnimation(0, "animation", true);
    this.unitView.addChild(glow, 1);
};

CollectibleHintView.prototype.hide = function (inTutorial) {
    if (!inTutorial && this.tutorialMode) {
        return;
    }
    FingerView.remove(this.hintFinger);
    this.hintFinger = undefined;

    const unitView = this.unitView;
    const glow = this.glow;
    const scaleAction = this.scaleAction;
    this.unitView = undefined;
    this.glow = undefined;
    this.scaleAction = undefined;

    if (glow) {
        glow.removeFromParent();
    }

    if (unitView && unitView.parent && scaleAction) {
        unitView.stopAction(scaleAction);
        unitView.runAction(new cc.ScaleTo(0.1, 1)).setFinalize(() => unitView.setScale(1));
    }
};

CollectibleHintView.prototype.setTutorialMode = function (tutorialMode) {
    this.tutorialMode = tutorialMode;
};
